import SideNavUserInfo from './SideNavUserInfo';

export default SideNavUserInfo;
